<template>
    <el-container direction="vertical" class="spreadsheet">
        <el-row type="flex" align="middle" class="spreadsheet-header" justify="space-between">
            <el-col :span="13">
                <div class="spreadsheet-header-title">
                    {{ title }}
                </div>
                <div class="spreadsheet-header-filter-info">
                    <span class="spreadsheet-header-filter-info_black">
                        Поиск по:
                    </span>
                    <span class="spreadsheet-header-filter-info_gray">
                        {{ filterTitle }}
                    </span>
                </div>
            </el-col>
            <el-col :span="2">
                <el-popover
                    popper-class="grid-search-dialog"
                    placement="top"
                    width="293"
                    trigger="click"
                    v-model="isFilterFormVisible"
                >
                    <el-button slot="reference" class="spreadsheet-header-button" type="warning">
                        поиск
                    </el-button>
                    <el-form label-position="top" @keyup.enter.native="filterApplied">
                        <el-form-item :label="fieldsNames.name" :label-width="formLabelWidth" v-if="isColumnVisible('name')">
                            <el-input v-model="filterModel.name" autocomplete="off" size="mini" clearable />
                        </el-form-item>
                        <el-form-item :label="fieldsNames.phone" :label-width="formLabelWidth" v-if="isColumnVisible('phone')">
                            <el-input v-model="filterModel.phone" autocomplete="off" size="mini" clearable />
                        </el-form-item>
                        <el-form-item :label="fieldsNames.email" :label-width="formLabelWidth" v-if="isColumnVisible('email')">
                            <el-input v-model="filterModel.email" autocomplete="off" size="mini" clearable />
                        </el-form-item>
                        <el-form-item :label="fieldsNames.address" :label-width="formLabelWidth" v-if="isColumnVisible('address')">
                            <el-input v-model="filterModel.address" autocomplete="off" size="mini" clearable />
                        </el-form-item>
                        <el-form-item :label="fieldsNames.comment" :label-width="formLabelWidth" v-if="isColumnVisible('comment')">
                            <el-input v-model="filterModel.comment" autocomplete="off" size="mini" clearable />
                        </el-form-item>
                    </el-form>
                    <div class="popover-footer">
                        <el-button @click="hideFilterForm">
                            Отменить
                        </el-button>
                        <el-button type="warning" @click="filterApplied">
                            Применить
                        </el-button>
                    </div>
                </el-popover>
            </el-col>
            <el-col :span="3">
                <span class="spreadsheet-header-total">
                    Всего записей: {{ pagesInfo.total }}
                </span>
            </el-col>
            <el-col :span="3">
                <el-button class="spreadsheet-header-button" type="warning" @click="goNewCard">
                    новая компания
                </el-button>
            </el-col>
            <el-col :span="1" title="Excel" class="icon-excel" v-if="isExcelButtonVisible">
                <div class="spreadsheet-header-excel">
                    &nbsp;
                </div>
            </el-col>
        </el-row>
        <el-row type="flex" align="top" class="spreadsheet-table" v-loading="loading">
            <el-col :span="24">
                <ag-grid-vue
                    class="ag-theme-balham spreadsheet-table-grid"
                    :grid-options="gridOptions"
                    :column-defs="columnDefs"
                />
            </el-col>
        </el-row>
        <el-row type="flex" align="bottom" class="spreadsheet-bar">
            <el-col :span="6">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="pagesInfo.total"
                    :page-size="pageModel.pageSize"
                    :current-page="pageModel.currentPage"
                    :small="true"
                    @current-change="getCurrentPage"
                />
            </el-col>
            <el-col :span="10">
                <div class="spreadsheet-bar-pages">
                    <span class="spreadsheet-bar-pages-title">
                        Выводить по:
                    </span>
                    <span
                        class="spreadsheet-bar-pages-size"
                        :class="{'is-active': isSetPageSize20}"
                        @click="setPageSize(20)"
                    >
                        20
                    </span>
                    <span
                        class="spreadsheet-bar-pages-size"
                        :class="{'is-active': isSetPageSize50}"
                        @click="setPageSize(50)"
                    >
                        50
                    </span>
                    <span
                        class="spreadsheet-bar-pages-size"
                        :class="{'is-active': isSetPageSize100}"
                        @click="setPageSize(100)"
                    >
                        100
                    </span>
                </div>
            </el-col>
            <el-col :span="8">
                <div class="spreadsheet-bar-total">
                    <span>
                        Строк выведено: {{ totalRows }} Из них выделено: {{ selectedRowsCount }}
                    </span>
                </div>
            </el-col>
        </el-row>
    </el-container>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue';
import TableHeaderSettings from '@/components/TableHeaderSettings';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import capitalize from 'lodash/capitalize';
import '@/assets/styles/list.scss';

library.add(faEye);

export default {
    name: 'CompaniesGrid',
    data() {
        return {
            title: 'Список компаний',
            isFilterFormVisible: false,
            filterModel: {
                name: null,
                phone: null,
                email: null,
                address: null,
                comment: null
            },
            fieldsNames: {
                name: 'компания',
                phone: 'телефон',
                email: 'e-mail',
                address: 'адрес',
                comment: 'комментарий'
            },
            pageModel: {
                currentPage: 1,
                pageSize: 20
            },
            formLabelWidth: '120px',
            totalRows: 0,
            selectedRowsCount: 0,
            loading: true,
            gridOptions: {
                rowSelection: 'multiple',
                suppressDragLeaveHidesColumns: false,
                suppressPaginationPanel: true,
                suppressLoadingOverlay: true,
                rowDeselection: true,
                enableCellTextSelection: true,
                headerHeight: 50,
                rowHeight: 40,
                domLayout: 'autoHeight',
                onRowDataChanged: this.onRowDataChanged.bind(this),
                onRowSelected: this.onRowSelected.bind(this),
                onColumnResized: this.onColumnResized.bind(this),
                onDisplayedColumnsChanged: this.onDisplayedColumnsChanged.bind(this),
                onRowDoubleClicked: this.onSelectionChanged.bind(this),
                onSortChanged: this.onSortChanged.bind(this),
                defaultColDef: {
                    sortable: true,
                    filter: false,
                    resizable: true,
                    cellClass: 'column-text',
                    comparator: () => {
                        return 0;
                    }
                }
            },
            columnDefs: [],
            companyOptions: []
        };
    },
    components: {
        'ag-grid-vue': AgGridVue
    },
    computed: {
        companies() {
            return this.$store.state.companies.companies;
        },
        pagesInfo() {
            return this.$store.state.companies.pages;
        },
        setting() {
            return this.$store.state.preferences.setting;
        },
        isSetPageSize20() {
            return this.pageModel.pageSize === 20;
        },
        isSetPageSize50() {
            return this.pageModel.pageSize === 50;
        },
        isSetPageSize100() {
            return this.pageModel.pageSize === 100;
        },
        filterTitle() {
            let result = '';
            for (const field in this.filterModel) {
                if (Object.prototype.hasOwnProperty.call(this.filterModel, field) && this.filterModel[field] && this.filterModel[field].length) {
                    result += (this.fieldsNames[field] + ': ' + this.filterModel[field] + '; ');
                }
            }
            return result;
        },
        isExcelButtonVisible() {
            //использовать в задаче реализации экспорта в excel
            return false;
        }
    },
    created() {
        this.columnDefs = [
            {
                headerName: this.capitalize(this.fieldsNames.name),
                field: 'name'
            },
            {
                headerName: this.capitalize(this.fieldsNames.phone),
                field: 'phone'
                /*cellRenderer: (params) => {
                 return masker(params.data.phone, '+# (###) ###-##-##', true, tokens);
                 }*/
            },
            {
                headerName: this.fieldsNames.email,
                field: 'email'
            },
            {
                headerName: this.capitalize(this.fieldsNames.address),
                field: 'address'
            },
            {
                headerName: this.capitalize(this.fieldsNames.comment),
                field: 'comment'
            },
            {
                headerName: '',
                field: '',
                headerComponentFramework: TableHeaderSettings,
                cellRenderer: (params) => {
                    return this.getLinkElement(params.data.id, 'div', 'cell-icon');
                },
                width: 40,
                cellClass: null
            }
        ];
    },
    mounted() {
        this.$store.dispatch('preferences/getPreferences').then(
            () => {
                this.setSettings();
            }).catch(() => {
            this.getDataFromServer();
        });
    },
    methods: {
        setSettings() {
            const settings = this.setting.companies;
            if (settings) {
                this.gridOptions.columnApi.setColumnState(settings.table);
                this.gridOptions.api.setSortModel(settings.sort);
                this.filterModel = JSON.parse(JSON.stringify(settings.filter));
                this.pageModel = JSON.parse(JSON.stringify(settings.page));
            } else {
                this.gridOptions.api.setSortModel({});
            }
        },
        hideFilterForm() {
            this.isFilterFormVisible = false;
        },
        getLinkElement(id, elementType, className) {
            const route = {
                name: 'company-card',
                params: { id: id }
            };
            const element = document.createElement(elementType);
            if (elementType === 'a') {
                element.href = this.$router.resolve(route).href;
                element.innerText = id;
            }
            element.className += ' ' + className;
            element.addEventListener('click', e => {
                e.preventDefault();
                this.$router.push(route);
            });
            return element;
        },
        onSelectionChanged(e) {
            this.$router.push({ name: 'company-card', params: { id: '' + e.node.data.id } });
        },
        getDataFromServer() {
            const requestParams = {
                size: this.pageModel.pageSize,
                page: this.pageModel.currentPage,
                sort: this.gridOptions.api.getSortModel(),
                filter: this.filterModel
            };
            this.loading = true;
            this.$store.dispatch('companies/getPaginatedList', requestParams).then(
                response => {
                    this.gridOptions.api.setRowData(this.companies);
                    this.pageModel.pageSize = +response.data.meta.per_page;
                    this.pageModel.currentPage = response.data.meta.current_page;
                    this.saveSetting();
                    this.loading = false;
                }).catch(
                error => {
                    if (error.response) {
                        this.loading = false;
                    }
                }).finally(() => {
                this.companyOptions = JSON.parse(JSON.stringify(this.companies));
            });
        },
        setPageSize(size) {
            this.pageModel.pageSize = size;
            this.getDataFromServer();
        },
        goNewCard() {
            this.$router.push({ name: 'company-card-new' });
        },
        getCurrentPage(page) {
            this.pageModel.currentPage = page;
            this.getDataFromServer();
        },
        filterApplied() {
            this.isFilterFormVisible = false;
            this.pageModel.currentPage = 1;
            this.getDataFromServer();
        },
        onRowDataChanged() {
            this.totalRows = this.gridOptions.api.getDisplayedRowCount();
        },
        onRowSelected() {
            this.selectedRowsCount = this.gridOptions.api.getSelectedRows().length;
        },
        isColumnVisible(colId) {
            return this.isFilterFormVisible && this.gridOptions.columnApi ? this.gridOptions.columnApi.getColumn(colId).visible : false;
        },
        onDisplayedColumnsChanged() {
            this.saveSetting();
        },
        onColumnResized(data) {
            if (data.finished && data.source === 'uiColumnDragged') {
                this.saveSetting();
            }
        },
        onSortChanged() {
            this.getDataFromServer();
        },
        async saveSetting() {
            const data = {
                'companies': {
                    'table': this.gridOptions.columnApi.getColumnState(),
                    'sort': this.gridOptions.api.getSortModel(),
                    'filter': this.filterModel,
                    'page': this.pageModel
                }
            };
            await this.$store.dispatch('preferences/setPreferences', data);
        },
        capitalize: capitalize
    }
};
</script>
